import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Landing() {
  const navigate = useNavigate();

  const features = [
    { icon:'🎙', title:'Digitized Broadcast Personas', desc:'Train an AI on your broadcast style. Clone your voice. Let it run shifts autonomously.', color:'#a78bfa' },
    { icon:'🤝', title:'Co-Anchor Modes', desc:'Two AI personas sharing a shift. Or go live yourself with an AI co-host that hears what you say.', color:'#a78bfa' },
    { icon:'💰', title:'Voice Marketplace', desc:'License your persona to other broadcasters. Earn 70% of every clip generated using your voice.', color:'#a78bfa' },
    { icon:'📻', title:'Autonomous Scheduling', desc:'Assign personas to program slots. Pre-generated buffers mean your station never goes silent.', color:'#a78bfa' },
    { icon:'🎵', title:'Voice Studio', desc:'Let anyone create a clip with your voice — greetings, DJ drops, ad reads. You earn every time.', color:'#a78bfa' },
    { icon:'🔒', title:'VoiceSeal Protection', desc:'Every clip is watermarked. Your voice identity is protected and every use is auditable.', color:'#a78bfa' },
  ];

  return (
    <div style={{ minHeight:'100vh', background:'#0a0a0f', color:'#f8fafc',
      fontFamily:'-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' }}>

      {/* Nav — matches business dashboard */}
      <nav style={{ display:'flex', alignItems:'center', justifyContent:'space-between',
        padding:'0 40px', height:60,
        borderBottom:'1px solid rgba(255,255,255,0.06)',
        position:'sticky', top:0, zIndex:100,
        background:'rgba(10,10,15,0.85)', backdropFilter:'blur(16px)' }}>
        {/* Logo — matches groovie business style */}
        <div style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer' }} onClick={() => { window.location.href = 'https://groovie.live'; }} title="Groovie home">
          <div style={{ width:28, height:28, borderRadius:7,
            background:'linear-gradient(135deg,#7c3aed,#6366f1)',
            display:'flex', alignItems:'center', justifyContent:'center', fontSize:14 }}>♪</div>
          <span style={{ fontSize:17, fontWeight:800, letterSpacing:'-0.5px', color:'#fff' }}>groovie</span>
          <span style={{ fontSize:10, fontWeight:700, letterSpacing:'2px', color:'#6b7280',
            textTransform:'uppercase', marginLeft:2 }}>BROADCAST</span>
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:32 }}>
          <a href="https://business.groovie.live" target="_blank" rel="noreferrer"
            style={{ color:'#9ca3af', fontSize:13, fontWeight:500, textDecoration:'none' }}>
            groovie business
          </a>
          <a href="https://groovie.live" target="_blank" rel="noreferrer"
            style={{ color:'#9ca3af', fontSize:13, fontWeight:500, textDecoration:'none' }}>
            groovie.live
          </a>
        </div>
        <div style={{ display:'flex', gap:10, alignItems:'center' }}>
          <button onClick={()=>navigate('/login')} style={{ background:'transparent',
            border:'none', color:'#9ca3af', padding:'8px 16px',
            fontSize:13, fontWeight:500, cursor:'pointer' }}>
            Sign in
          </button>
          <button onClick={()=>navigate('/register')} style={{ background:'#fff',
            border:'none', color:'#0a0a0f', padding:'9px 20px',
            borderRadius:8, fontSize:13, fontWeight:700, cursor:'pointer' }}>
            Get started
          </button>
        </div>
      </nav>

      {/* Hero */}
      <div style={{ textAlign:'center', padding:'120px 24px 80px' }}>
        <div style={{ fontSize:13, fontWeight:800, letterSpacing:'2px',
          color:'#a78bfa', marginBottom:14 }}>
          Radio as a Service · Autonomous Radio Infrastructure
        </div>
        <div style={{ fontSize:11, fontWeight:700, letterSpacing:'3px',
          color:'#6b7280', textTransform:'uppercase', marginBottom:28 }}>
          YOUR VOICE. YOUR STATION. YOUR REVENUE.
        </div>
        <h1 style={{ fontSize:'clamp(40px,7vw,80px)', fontWeight:900,
          lineHeight:1.0, margin:'0 0 28px', letterSpacing:'-3px' }}>
          The broadcast platform<br />
          <span style={{ color:'#6b7280', fontWeight:800 }}>your voice deserves</span>
        </h1>
        <p style={{ fontSize:17, color:'#6b7280', maxWidth:580, margin:'0 auto 20px', lineHeight:1.7 }}>
          Groovie Broadcast gives you more than a radio station.
          It gives you an AI trained on your style — broadcasting, earning, and growing while you sleep.
        </p>
        <p style={{ fontSize:15, color:'#6b7280', margin:'0 auto 44px' }}>
          Broadcast your voice, earn from every clip, and license to the world.
        </p>
        <div style={{ display:'flex', gap:12, justifyContent:'center', flexWrap:'wrap' }}>
          <button onClick={()=>navigate('/register')} style={{ background:'#fff',
            border:'none', color:'#0a0a0f', padding:'14px 32px',
            borderRadius:9, fontSize:14, fontWeight:700, cursor:'pointer' }}>
            Start broadcasting
          </button>
          <button onClick={()=>navigate('/login')} style={{ background:'transparent',
            border:'1px solid rgba(255,255,255,0.15)', color:'#f8fafc', padding:'14px 32px',
            borderRadius:9, fontSize:14, fontWeight:600, cursor:'pointer' }}>
            View demo
          </button>
        </div>

        {/* Trust strip */}
        <div style={{ display:'flex', justifyContent:'center', gap:32, marginTop:40, flexWrap:'wrap' }}>
          {['No credit card required','Typically live the same day, subject to setup requirements','VoiceSeal protected','Cancel at the end of your paid month'].map(t=>(
            <div key={t} style={{ display:'flex', alignItems:'center', gap:6, fontSize:12, color:'#4b5563' }}>
              <span style={{ width:5, height:5, borderRadius:'50%', background:'#6366f1', display:'inline-block' }} />
              {t}
            </div>
          ))}
        </div>
      </div>

      {/* Marquee strip */}
      <div style={{ borderTop:'1px solid rgba(255,255,255,0.05)', borderBottom:'1px solid rgba(255,255,255,0.05)',
        padding:'16px 0', overflow:'hidden' }}>
        <div style={{ display:'flex', gap:48, justifyContent:'center', flexWrap:'wrap',
          fontSize:11, fontWeight:700, letterSpacing:'2px', color:'#374151', textTransform:'uppercase' }}>
          {['VOICE CLONING','AUTONOMOUS SHIFTS','CO-ANCHOR AI','VOICE MARKETPLACE','70% REVENUE SHARE','VOICESEAL PROTECTED','WHISPER TRANSCRIPTION','NO DEAD AIR'].map(t=>(
            <span key={t}>{t}</span>
          ))}
        </div>
      </div>

      {/* Features */}
      <div style={{ maxWidth:1100, margin:'0 auto', padding:'100px 24px' }}>
        <div style={{ textAlign:'center', marginBottom:64 }}>
          <h2 style={{ fontSize:'clamp(28px,4vw,44px)', fontWeight:900,
            letterSpacing:'-1.5px', margin:'0 0 16px' }}>
            Everything your broadcast needs
          </h2>
          <p style={{ fontSize:15, color:'#6b7280', margin:0, maxWidth:480, marginLeft:'auto', marginRight:'auto' }}>
            Built for independent broadcasters who want to sound professional and earn from their voice.
          </p>
        </div>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(300px,1fr))', gap:2 }}>
          {features.map((f,i) => (
            <div key={f.title} style={{ padding:32,
              borderTop:'1px solid rgba(255,255,255,0.05)',
              borderLeft: i%3===0 ? 'none' : '1px solid rgba(255,255,255,0.05)',
              transition:'background 0.2s' }}
              onMouseEnter={e=>e.currentTarget.style.background='rgba(255,255,255,0.02)'}
              onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
              <div style={{ fontSize:28, marginBottom:16 }}>{f.icon}</div>
              <h3 style={{ fontSize:15, fontWeight:700, margin:'0 0 10px', color:'#e5e7eb' }}>{f.title}</h3>
              <p style={{ fontSize:13, color:'#4b5563', margin:0, lineHeight:1.6 }}>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* How it works */}
      <div style={{ borderTop:'1px solid rgba(255,255,255,0.05)', padding:'100px 24px' }}>
        <div style={{ maxWidth:900, margin:'0 auto', textAlign:'center' }}>
          <h2 style={{ fontSize:'clamp(28px,4vw,44px)', fontWeight:900,
            letterSpacing:'-1.5px', margin:'0 0 64px' }}>
            From voice to revenue in 4 steps
          </h2>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(180px,1fr))', gap:48 }}>
            {[
              { step:'01', title:'Create your persona', desc:'Name it, define the personality and energy' },
              { step:'02', title:'Upload broadcast audio', desc:'AI extracts your style. Voice gets cloned automatically.' },
              { step:'03', title:'Schedule your shift', desc:'Assign your persona to any program slot' },
              { step:'04', title:'Go live and earn', desc:'AI runs the shift. You earn from every clip generated.' },
            ].map(s => (
              <div key={s.step}>
                <div style={{ fontSize:40, fontWeight:900, color:'rgba(255,255,255,0.06)',
                  marginBottom:16, letterSpacing:'-2px', lineHeight:1 }}>{s.step}</div>
                <h4 style={{ fontSize:14, fontWeight:700, margin:'0 0 8px', color:'#e5e7eb' }}>{s.title}</h4>
                <p style={{ fontSize:12, color:'#4b5563', margin:0, lineHeight:1.6 }}>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA */}
      <div style={{ borderTop:'1px solid rgba(255,255,255,0.05)', textAlign:'center', padding:'100px 24px' }}>
        <h2 style={{ fontSize:'clamp(28px,4vw,52px)', fontWeight:900,
          letterSpacing:'-2px', margin:'0 0 20px' }}>
          Ready to broadcast?
        </h2>
        <p style={{ fontSize:16, color:'#6b7280', margin:'0 0 40px' }}>
          Set up your station and create your first persona in under 5 minutes.
        </p>
        <button onClick={()=>navigate('/register')} style={{ background:'#fff',
          border:'none', color:'#0a0a0f', padding:'16px 40px', borderRadius:10,
          fontSize:15, fontWeight:700, cursor:'pointer' }}>
          Start broadcasting →
        </button>
        <div style={{ marginTop:16, fontSize:12, color:'#374151' }}>
          No credit card required · 70% revenue share · VoiceSeal protected
        </div>
      </div>

      {/* Footer */}
      <div style={{ borderTop:'1px solid rgba(255,255,255,0.06)', padding:'28px 40px',
        display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:12 }}>
        <div style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer' }} onClick={() => { window.location.href = 'https://groovie.live'; }} title="Groovie home">
          <div style={{ width:22, height:22, borderRadius:5,
            background:'linear-gradient(135deg,#7c3aed,#6366f1)',
            display:'flex', alignItems:'center', justifyContent:'center', fontSize:11 }}>♪</div>
          <span style={{ fontSize:14, fontWeight:800, letterSpacing:'-0.5px' }}>groovie</span>
          <span style={{ fontSize:9, fontWeight:700, letterSpacing:'2px', color:'#374151',
            textTransform:'uppercase' }}>BROADCAST</span>
        </div>
        <div style={{ fontSize:12, color:'#374151' }}>© 2026 Gooverio Labs, Inc.</div>
        <div style={{ display:'flex', gap:24 }}>
          <button onClick={()=>navigate('/login')} style={{ background:'none', border:'none',
            color:'#374151', fontSize:12, cursor:'pointer' }}>Sign in</button>
          <button onClick={()=>navigate('/register')} style={{ background:'none', border:'none',
            color:'#374151', fontSize:12, cursor:'pointer' }}>Register</button>
          <a href="https://groovie.live" target="_blank" rel="noreferrer"
            style={{ color:'#374151', fontSize:12, textDecoration:'none' }}>groovie.live</a>
          <a href="https://business.groovie.live" target="_blank" rel="noreferrer"
            style={{ color:'#374151', fontSize:12, textDecoration:'none' }}>business</a>
        </div>
      </div>
    </div>
  );
}
